// extracted by mini-css-extract-plugin
export default {"wrapper":"MD4oi","message-content":"MoS3W","footer":"WGLgV"};